import Card from 'react-bootstrap/Card';

function ContactCard() {

  const MyStyle1 =  {
          color: "white",
          fontSize: "5.0vmin"        
      }

  const MyStyle2 =  {
          color: "black",
          fontSize: "6.0vmin"        
      }

  return (
    <Card style={{ width: "95%", color: "#676266", backgroundColor: "#c7afc3"}}>      
      <Card.Body>        
        <br/>
        <div style={MyStyle1}>
            Telefon:
        </div>
        <div style={MyStyle2}>
          +49 160 640 3151
        </div>
        <br/>
        <div style={MyStyle1}>
            Email:
        </div>
        <div style={MyStyle2}>
          <a href="mailto:messagebox@raliwa.de?subject=Anfrage MessageBox">messagebox@raliwa.de</a>          
        </div>        
        <br/>
      </Card.Body>
    </Card>
  );
}

export default ContactCard;
